import type { FunctionalComponent as FC } from 'preact';
import { useCallback } from 'preact/hooks';

import { Spinner } from '@vkontakte/vkui';

import { useVkCaptchaContext } from '../../context/VkCaptchaContext';
import { useMessagesTracking } from '../../hooks/useMessagesTracking';
import type { Message } from '../../types/messages';
import { tokenManager } from '../../utils';

import { EmptyWidgetContent } from '../EmptyWidgetContent';
import { InfiniteScroll } from '../InfiniteScroll';
import { MessagesList } from '../MessagesList';

import styles from './styles.module.css';

interface Props {
  messages: Message[];
  handleGetHistory: () => Promise<void>;
  hasNextPage: boolean;
  isLoading: boolean;
}

export const WidgetContent: FC<Props> = ({ messages, handleGetHistory, hasNextPage, isLoading }) => {
  const hasNoMessages = messages.length === 0;
  const { handleCaptchaOpen } = useVkCaptchaContext();

  const { listRef } = useMessagesTracking();

  const isTokenExpired = tokenManager.getIsTokenExpired();

  const handleLoadMore = useCallback(() => {
    if (isTokenExpired) {
      handleCaptchaOpen();
    } else {
      void handleGetHistory();
    }
  }, [handleCaptchaOpen, handleGetHistory, isTokenExpired]);

  // Показываем спиннер по центру при первой загрузке истории
  if (hasNoMessages && isLoading) {
    return (
      <div className={styles.loadingContainer}>
        <Spinner size="l" />
      </div>
    );
  }

  if (hasNoMessages) {
    return <EmptyWidgetContent />;
  }

  return (
    <InfiniteScroll hasNextPage={hasNextPage} isLoading={isLoading} onLoadMore={handleLoadMore} listRef={listRef}>
      <MessagesList messages={messages} isLoading={isLoading} />
    </InfiniteScroll>
  );
};
